import React, { useEffect, useRef } from 'react';
import styled, { keyframes } from 'styled-components';
import { FaTimes } from 'react-icons/fa';

// Keyframes for animation
const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const slideIn = keyframes`
  from {
    transform: translateY(-50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

const PopupOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000; /* Ensure it's on top of everything */
  animation: ${fadeIn} 0.3s ease-out forwards;
`;

const PopupContent = styled.div`
  background-color: #fff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.3);
  position: relative;
  max-width: 90%;
  max-height: 90%;
  overflow: hidden; /* Ensure image fits */
  display: flex;
  flex-direction: column;
  animation: ${slideIn} 0.4s ease-out forwards;

  @media (min-width: 768px) {
    max-width: 600px; /* Adjust max-width for larger screens */
    max-height: 600px;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 1.8em;
  color: #333;
  cursor: pointer;
  z-index: 10; /* Ensure button is clickable */

  &:hover {
    color: #e67e22;
  }
`;

const PopupImage = styled.img`
  max-width: 100%;
  max-height: 100%;
  height: auto;
  border-radius: 8px;
  object-fit: contain; /* Ensure image fits well */
`;

const PromoPopup = ({ isOpen, onClose, imageUrl, altText = "Promotional offer" }) => {
  const popupRef = useRef(null);

  // Close popup if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <PopupOverlay>
      <PopupContent ref={popupRef}>
        <CloseButton onClick={onClose}>
          <FaTimes />
        </CloseButton>
        <PopupImage src={imageUrl} alt={altText} />
      </PopupContent>
    </PopupOverlay>
  );
};

export default PromoPopup;